module.exports = __webpack_public_path__ + "img/bg.52136176.png";